import React, { memo, useMemo } from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Skeleton from "@mui/material/Skeleton";
import { useSelector } from "react-redux";
import { ENTITY_TYPES } from "../../../utils";

const CustomBreadcrumbSx = {
  display: "inline-block",
  verticalAlign: "bottom",
};

const CustomBreadcrumb = ({ entityType }) => {
  const { departmentLetter } = useParams();

  const departmentName = useSelector(
    (store) => store.itemPogSummary.department
  );

  const planogramName = useSelector(
    (store) => store.itemPogSummary.planogramName
  );

  const details = useMemo(() => {
    let navPoints = [];

    if (ENTITY_TYPES.item === entityType) {
      navPoints = [
        {
          label: departmentName,
          href: "/manage-planograms/departments",
          isActive: true,
        },
        {
          label: planogramName,
          href: `/manage-planograms/pogs/${departmentLetter}`,
          isActive: true,
        },
      ];
    } else {
      navPoints = [
        {
          label: departmentName,
          href: "/manage-planograms/departments",
          isActive: true,
        },
      ];
    }
    return !!departmentName || !!planogramName ? navPoints : [];
  }, [departmentName, planogramName, departmentLetter, entityType]);

  const breadcrumbLoadingRenderer = useMemo(() => {
    if (ENTITY_TYPES.item === entityType) {
      return (
        <>
          <Skeleton
            variant="rounded"
            width={130}
            height={20}
            sx={CustomBreadcrumbSx}
          />{" "}
          /{" "}
          <Skeleton
            variant="rounded"
            width={130}
            height={20}
            sx={CustomBreadcrumbSx}
          />
        </>
      );
    } else if (ENTITY_TYPES.planogram === entityType) {
      return (
        <>
          <Skeleton
            variant="rounded"
            width={130}
            height={20}
            sx={CustomBreadcrumbSx}
          />
        </>
      );
    } else {
      return <></>;
    }
  }, [entityType]);

  return (
    <div role="presentation">
      {!!details.length ? (
        <Breadcrumbs aria-label="breadcrumb">
          {details.map((link) => (
            <Link
              key={link?.href}
              variant="caption"
              lineHeight="unset"
              underline="hover"
              fontWeight={600}
              color={link?.isActive ? "primary" : "inherit"}
              href={link?.href}
            >
              {link?.label}
            </Link>
          ))}
        </Breadcrumbs>
      ) : (
        breadcrumbLoadingRenderer
      )}
    </div>
  );
};

export default memo(CustomBreadcrumb);
